(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7396],{

/***/ 17396:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(828);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var wavesurfer_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(21796);
/* harmony import */ var wavesurfer_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(wavesurfer_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _material_ui_core_Slider__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(59122);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var components_common_Icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(37975);
/* harmony import */ var store_timeline__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12800);
/* harmony import */ var store_global__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8405);
/* harmony import */ var common_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22467);
/* harmony import */ var common_interfaces_api__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(21694);
/* harmony import */ var _AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(87978);
/* harmony import */ var _AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _PlayerRateOptions__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(64739);
/* harmony import */ var components_common_Button__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(98133);
/* harmony import */ var common_utils_membership__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(77063);
/* harmony import */ var common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(67027);
/* harmony import */ var common_utils_post__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(40783);
/* harmony import */ var service_media__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(94895);
/* harmony import */ var _amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(38367);
























var formWaveSurferOptions = function(ref) {
    return {
        container: ref,
        backgroundColor: "#0ABC71",
        waveColor: "rgba(255, 255, 255, 0.33)",
        progressColor: "#ffffff",
        cursorColor: "transparent",
        barWidth: 4,
        barGap: 0,
        height: 100,
        hideScrollbar: true,
        normalize: true,
        backend: "MediaElement"
    };
};
function AudioPlayer(param) {
    var id = param.id, url = param.url, trackTitle = param.trackTitle, postAuthor = param.postAuthor, _parent = param.parent, parent = _parent === void 0 ? "timeline" : _parent, _isGlobal = param.isGlobal, isGlobal = _isGlobal === void 0 ? false : _isGlobal, _titleEditable = param.titleEditable, titleEditable = _titleEditable === void 0 ? false : _titleEditable, editableTitle = param.editableTitle, onChangeTitle = param.onChangeTitle, _isLocked = param.isLocked, isLocked = _isLocked === void 0 ? false : _isLocked, spectrum = param.spectrum, _duration = param.duration, duration = _duration === void 0 ? 0 : _duration, _isPostDetail = param.isPostDetail, isPostDetail = _isPostDetail === void 0 ? false : _isPostDetail, postType = param.postType, thumbnailUrl = param.thumbnailUrl, canSeeFreeMinutes = param.canSeeFreeMinutes, freeMinutes = param.freeMinutes, freeUrl = param.freeUrl, postSource = param.postSource;
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var deviceInfo = (0,common_utils__WEBPACK_IMPORTED_MODULE_9__/* .useDevice */ .Fy)();
    var isMobile = !deviceInfo.isDesktop;
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,store_timeline__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(function(state) {
        return [
            state.activeAudioPlayer,
            state.setActiveAudioPlayer, 
        ];
    }), 2), activeAudioPlayer = ref1[0], setActiveAudioPlayer = ref1[1];
    var currentAuth = (0,store_global__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(state) {
        return state.currentAuth;
    });
    var currentUser = (0,store_timeline__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(function(state) {
        return state.currentUser;
    });
    var activeVideoPlayer = (0,store_timeline__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP)(function(state) {
        return state.activeVideoPlayer;
    });
    var showLogin = (0,store_global__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(state) {
        return state.showLogin;
    });
    var setShowMembershipPayDialog = (0,store_global__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(state) {
        return state.setShowMembershipPayDialog;
    });
    var showPaymentDialog = (0,store_global__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(state) {
        return state.showPaymentDialog;
    });
    var playerId = parent + id.toString();
    var isActive = playerId === (activeAudioPlayer === null || activeAudioPlayer === void 0 ? void 0 : activeAudioPlayer.id);
    var isActiveRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(isActive);
    var setSnackbarMessage = (0,store_global__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(state) {
        return state.setSnackbarMessage;
    });
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), playedFreeTimes = ref2[0], setPlayedFreeTimes = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), remainingFreeSeconds = ref3[0], setRemainingFreeSeconds = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), playbackRate = ref4[0], setPlaybackRate = ref4[1];
    var postUrl = "/".concat(postAuthor.username, "/posts/").concat(id);
    var waveformRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var wavesurfer = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), playing = ref5[0], setPlaying = ref5[1];
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), hasEnded = ref6[0], setHasEnded = ref6[1];
    var ref7 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(true), isLoading = ref7[0], setLoading = ref7[1];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), currentTime = ref8[0], setCurrentTime = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), isHidden = ref9[0], setHidden = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(1), volume = ref10[0], setVolume = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0), timebarVal = ref11[0], setTimebarVal = ref11[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(-1), lastClickTime = ref12[0], setLastClickTime = ref12[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setPlayedFreeTimes(0);
    }, [
        id
    ]);
    var isMiniModeActive = isActive && (isHidden || isGlobal);
    var audioPlayerRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var intersectionCb = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function(entries) {
        var target = entries[0];
        if (target) {
            if (target.isIntersecting) {
                // audio player showing
                setHidden(false);
            } else {
                // audio player ofsscreen
                setHidden(true);
            }
        }
    }, []);
    // Timebar
    var handleTimebarChange = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(e) {
            var newTimebarVal;
            return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        e.stopPropagation();
                        if (!titleEditable) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        if (currentAuth) {
                            _ctx.next = 6;
                            break;
                        }
                        showLogin(router.pathname === "/" ? {
                            redirectUrl: postUrl
                        } : {});
                        return _ctx.abrupt("return");
                    case 6:
                        if (!isLocked) {
                            _ctx.next = 8;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 8:
                        if (!(!isPostDetail && !isActive)) {
                            _ctx.next = 13;
                            break;
                        }
                        (0,common_utils_post__WEBPACK_IMPORTED_MODULE_15__/* .addClickPostEvent */ .lR)({
                            postId: id,
                            screen: (0,common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_14__/* .parentKeyToScreenName */ .lF)(parent),
                            postSource: postSource,
                            clickPosition: "media_view",
                            postType: postType,
                            mediaType: service_media__WEBPACK_IMPORTED_MODULE_16__/* .MediaType.Audio */ .D.Audio
                        });
                        _ctx.next = 12;
                        return router.push(postUrl);
                    case 12:
                        return _ctx.abrupt("return");
                    case 13:
                        if (wavesurfer.current) {
                            _ctx.next = 15;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 15:
                        newTimebarVal = Number(e.target.value);
                        if (!(isNaN(newTimebarVal) || newTimebarVal < 0 || newTimebarVal > 1)) {
                            _ctx.next = 18;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 18:
                        wavesurfer.current.seekTo(newTimebarVal);
                        setTimebarVal(newTimebarVal);
                        if (newTimebarVal === 1) {
                            setPlaying(false);
                            setHasEnded(true);
                            void wavesurfer.current.pause();
                        } else {
                            setPlaying(true);
                            setHasEnded(false);
                            void wavesurfer.current.play();
                        }
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleTimebarChange(e) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleTrialClick = function(e) {
        e.stopPropagation();
        if (postType === common_interfaces_api__WEBPACK_IMPORTED_MODULE_10__/* .PostType.Gold */ .hQ.Gold && !(0,common_utils_membership__WEBPACK_IMPORTED_MODULE_13__/* .isGoldMember */ .Ic)(currentUser)) {
            setShowMembershipPayDialog({
                open: true,
                showMembershipStatus: false,
                initPackage: common_interfaces_api__WEBPACK_IMPORTED_MODULE_10__/* .MembershipPackageName.Platinum */ .uh.Platinum,
                screen: common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_14__/* .ScreenName.PostDetail */ .CG.PostDetail
            });
            return;
        }
        if (!postAuthor) return;
        // in case of value is undefined, still can open payment dialog
        if (postAuthor.is_open_for_subscription === false && (0,common_utils_post__WEBPACK_IMPORTED_MODULE_15__/* .checkIsCreatorPaidPost */ .b8)(postType)) {
            setSnackbarMessage({
                type: "error",
                text: (0,common_utils_post__WEBPACK_IMPORTED_MODULE_15__/* .exCreatorPostLockMessage */ .e8)(postType)
            });
            return;
        }
        showPaymentDialog({
            creator: postAuthor
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (isLocked && !canSeeFreeMinutes || isGlobal) return;
        var ref = audioPlayerRef.current;
        var options = {
            root: null,
            rootMargin: isMobile ? "10px" : thumbnailUrl ? "240px" : "10px",
            threshold: 0.2
        };
        // Create observer
        var observer = new IntersectionObserver(intersectionCb, options);
        var scrollCheck = setTimeout(function() {
            // observe the audio player
            if (ref) {
                observer.observe(ref);
            }
        }, 500);
        // clean up on willUnMount
        return function() {
            if (ref) {
                observer.unobserve(ref);
            }
            scrollCheck && clearTimeout(scrollCheck);
        };
    // Note: for some reasone audioPlayer.current needs to be in the dependency array
    // otherwise initial target.isIntersecting will always be false
    }, [
        intersectionCb,
        isLocked,
        isGlobal,
        thumbnailUrl,
        isMobile,
        canSeeFreeMinutes, 
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!canSeeFreeMinutes) return;
        var rmFreeSecs = Math.round(Math.max(0, Math.min(freeMinutes * 60, duration) - currentTime));
        setRemainingFreeSeconds(rmFreeSecs);
        if (rmFreeSecs === 1) {
            setPlayedFreeTimes(0);
            wavesurfer.current.seekTo(0);
            wavesurfer.current.pause();
            setPlaying(false);
            showPaymentDialog({
                creator: postAuthor
            });
        }
    }, [
        canSeeFreeMinutes,
        currentTime,
        duration,
        freeMinutes,
        postAuthor,
        showPaymentDialog, 
    ]);
    var currentUrl = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (!isPostDetail) return common_utils__WEBPACK_IMPORTED_MODULE_9__/* .AUDIO_TMP_URL */ .Qk;
        var newUrl = canSeeFreeMinutes && freeUrl ? freeUrl : isLocked ? common_utils__WEBPACK_IMPORTED_MODULE_9__/* .AUDIO_TMP_URL */ .Qk : url;
        return newUrl || common_utils__WEBPACK_IMPORTED_MODULE_9__/* .AUDIO_TMP_URL */ .Qk;
    }, [
        canSeeFreeMinutes,
        freeUrl,
        isLocked,
        isPostDetail,
        url
    ]);
    // create new WaveSurfer instance
    // On component mount and when url changes
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        try {
            if (!currentUrl) return;
            setPlaying(false);
            var options = formWaveSurferOptions(waveformRef.current);
            wavesurfer.current = wavesurfer_js__WEBPACK_IMPORTED_MODULE_3___default().create(options);
            wavesurfer.current.load(currentUrl, spectrum);
            if (currentUrl === common_utils__WEBPACK_IMPORTED_MODULE_9__/* .AUDIO_TMP_URL */ .Qk) {
                setLoading(false);
            }
            wavesurfer.current.on("ready", function() {
                setLoading(false);
                // make sure object stillavailable when file loaded
                if (wavesurfer.current) {
                    if (!isLocked && playedFreeTimes > 0) {
                        wavesurfer.current.setCurrentTime(Math.min(playedFreeTimes, wavesurfer.current.getDuration() - 1));
                        void wavesurfer.current.play();
                        setPlaying(true);
                        setPlayedFreeTimes(0);
                    }
                    wavesurfer.current.setVolume(1);
                }
            });
            wavesurfer.current.on("finish", function() {
                setHasEnded(true);
                setPlaying(false);
            });
            wavesurfer.current.on("audioprocess", function() {
                var currentTime = wavesurfer.current.getCurrentTime();
                if (currentTime < 0) currentTime = 0;
                setTimebarVal(wavesurfer.current.getCurrentTime() / duration);
                setCurrentTime(currentTime);
                if (canSeeFreeMinutes) {
                    setPlayedFreeTimes(currentTime);
                }
            });
            wavesurfer.current.on("seek", function() {
                var currentTime = wavesurfer.current.getCurrentTime();
                if (currentTime < 0) currentTime = 0;
                setTimebarVal(wavesurfer.current.getCurrentTime() / duration);
                setCurrentTime(currentTime);
            });
            wavesurfer.current.on("volume", function(volume) {
                setVolume(volume);
            });
        } catch (error) {
            console.error(error);
        }
        // Removes events, elements and disconnects Web Audio nodes.
        // when component unmount
        return function() {
            return wavesurfer.current.destroy();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        currentUrl,
        spectrum
    ]);
    var draw = function() {
        try {
            if (wavesurfer.current) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                wavesurfer.current.drawBuffer();
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                var backend = wavesurfer.current.backend;
                // redraw the progress when player changes form
                // eslint-disable-next-line
                wavesurfer.current.drawer.progress(backend.getPlayedPercents());
            }
        // eslint-disable-next-line no-empty
        } catch (error) {}
    };
    // redraw the bars when the player changes form
    // TODO: FIXME: using internal methods of wavesurfer.js
    // may not work on newer versions
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        draw();
    }, [
        isHidden
    ]);
    // Stop playing when video starts playing with sound
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (activeVideoPlayer && activeVideoPlayer.muted === false) {
            if (wavesurfer.current && wavesurfer.current.isPlaying) {
                void wavesurfer.current.pause();
                setPlaying(false);
            }
        }
    }, [
        activeVideoPlayer
    ]);
    // Stop playing when other audio sources are playing
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (!isActive && wavesurfer.current && wavesurfer.current.isPlaying) {
            void wavesurfer.current.pause();
            setPlaying(false);
        }
        isActiveRef.current = isActive;
    }, [
        isActive
    ]);
    // Set current audio as active if it is playing
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (playing) {
            setActiveAudioPlayer(playerId, true);
        } else {
            if (isActiveRef.current) {
                setActiveAudioPlayer(playerId, false);
            }
        }
    }, [
        playing,
        playerId,
        setActiveAudioPlayer
    ]);
    var handlePlayPause = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(e) {
            return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!titleEditable) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (!(!isPostDetail && !isActive)) {
                            _ctx.next = 7;
                            break;
                        }
                        (0,common_utils_post__WEBPACK_IMPORTED_MODULE_15__/* .addClickPostEvent */ .lR)({
                            postId: id,
                            screen: (0,common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_14__/* .parentKeyToScreenName */ .lF)(parent),
                            postSource: postSource,
                            clickPosition: "media_view",
                            postType: postType,
                            mediaType: service_media__WEBPACK_IMPORTED_MODULE_16__/* .MediaType.Audio */ .D.Audio
                        });
                        _ctx.next = 6;
                        return router.push(postUrl);
                    case 6:
                        return _ctx.abrupt("return");
                    case 7:
                        if (currentAuth) {
                            _ctx.next = 10;
                            break;
                        }
                        showLogin({});
                        return _ctx.abrupt("return");
                    case 10:
                        if (wavesurfer.current) {
                            _ctx.next = 12;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 12:
                        if (!isLocked || canSeeFreeMinutes) {
                            if (playing) {
                                void wavesurfer.current.pause();
                                setPlaying(false);
                            } else {
                                void wavesurfer.current.play();
                                setPlaying(true);
                                (0,_amplitude_analytics_browser__WEBPACK_IMPORTED_MODULE_19__/* .track */ .j)("Start Play Audio");
                                (0,common_utils__WEBPACK_IMPORTED_MODULE_9__/* .increaseViewCount */ .wh)(id);
                            }
                            setHasEnded(false);
                        } else {
                            handleTrialClick(e);
                        }
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handlePlayPause(e) {
            return _ref.apply(this, arguments);
        };
    }();
    // Rewind and fast forward with
    // - positivie skipTime means fast forward
    // - negative skipTime means rewind
    var handleTimeSkip = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(skipTime) {
            var newTime;
            return _home_circleci_project_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!titleEditable) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        if (currentAuth) {
                            _ctx.next = 5;
                            break;
                        }
                        showLogin(router.pathname === "/" ? {
                            redirectUrl: postUrl
                        } : {});
                        return _ctx.abrupt("return");
                    case 5:
                        if (!(!isPostDetail && !isActive)) {
                            _ctx.next = 10;
                            break;
                        }
                        (0,common_utils_post__WEBPACK_IMPORTED_MODULE_15__/* .addClickPostEvent */ .lR)({
                            postId: id,
                            screen: (0,common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_14__/* .parentKeyToScreenName */ .lF)(parent),
                            postSource: postSource,
                            clickPosition: "media_view",
                            postType: postType,
                            mediaType: service_media__WEBPACK_IMPORTED_MODULE_16__/* .MediaType.Audio */ .D.Audio
                        });
                        _ctx.next = 9;
                        return router.push(postUrl);
                    case 9:
                        return _ctx.abrupt("return");
                    case 10:
                        if (!(isLocked && !canSeeFreeMinutes)) {
                            _ctx.next = 12;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 12:
                        if (wavesurfer === null || wavesurfer === void 0 ? void 0 : wavesurfer.current) {
                            _ctx.next = 14;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 14:
                        if (skipTime < 0) {
                            (0,common_utils__WEBPACK_IMPORTED_MODULE_9__/* .increaseViewCount */ .wh)(id);
                        }
                        newTime = wavesurfer.current.getCurrentTime() + skipTime;
                        if (newTime > wavesurfer.current.getDuration()) newTime = wavesurfer.current.getDuration() - 1;
                        if (newTime < 0) newTime = 0;
                        setCurrentTime(newTime);
                        setTimebarVal(newTime / duration);
                        wavesurfer.current.setCurrentTime(newTime);
                    case 21:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleTimeSkip(skipTime) {
            return _ref.apply(this, arguments);
        };
    }();
    var mediaControlBtn = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        if (hasEnded) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                name: "replay-2",
                width: 42,
                height: 42
            });
        } else {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                name: "pause-2",
                width: 42,
                height: 42,
                hasOn: true,
                isOn: !playing
            });
        }
    }, [
        hasEnded,
        playing
    ]);
    var handleCloseBtn = function() {
        setActiveAudioPlayer(null, null);
    };
    // Volume
    var handleVolumeChange = function(e, newVolume) {
        if (!(0,common_utils__WEBPACK_IMPORTED_MODULE_9__/* .isNumber */ .hj)(newVolume) || Array.isArray(newVolume)) {
            newVolume = 0.5;
        }
        wavesurfer.current.setVolume(newVolume);
    };
    var handleSpeakerClick = function() {
        if (!wavesurfer.current) return;
        wavesurfer.current.toggleMute();
    };
    var handleChangePlaybackRate = function(newRate) {
        if (!(wavesurfer === null || wavesurfer === void 0 ? void 0 : wavesurfer.current)) return;
        setPlaybackRate(newRate);
        wavesurfer.current.setPlaybackRate(newRate);
    };
    var _obj;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
        style: {
            minHeight: isGlobal ? "0" : "115px"
        },
        children: [
            !isGlobal && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().invisible),
                ref: audioPlayerRef
            }),
            !isMiniModeActive && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ThumbnailImageFull, {
                thumbnailUrl: thumbnailUrl,
                postUrl: postUrl,
                isPostDetail: isPostDetail,
                parent: parent,
                postSource: postSource,
                trackTitle: trackTitle,
                postId: id,
                postType: postType
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_4___default()((_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().audioPlayerWrapper), (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_obj, (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().floating), isMiniModeActive), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z)(_obj, (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().hasThumbnail), !!thumbnailUrl), _obj)),
                children: [
                    isMiniModeActive && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().closeBtn),
                        onClick: handleCloseBtn,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                            name: "close-2",
                            width: 24,
                            height: 24
                        })
                    }),
                    isMiniModeActive && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ThumbnailImageMini, {
                        thumbnailUrl: thumbnailUrl
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                        className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().audioBody),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().trackInfo),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().trackAuthor),
                                        children: postAuthor === null || postAuthor === void 0 ? void 0 : postAuthor.name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().trackTitle),
                                        children: titleEditable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                            autoFocus: true,
                                            type: "text",
                                            placeholder: "タイトルをつける",
                                            className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().titleInput),
                                            value: editableTitle,
                                            onChange: function(e) {
                                                return onChangeTitle(e.target.value);
                                            }
                                        }) : trackTitle
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().bottom),
                                children: [
                                    isLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                        className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().loading),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                                            name: "loading-anim-2",
                                            width: 30,
                                            height: 30
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().center),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().waveformContainer),
                                                style: canSeeFreeMinutes ? {
                                                    visibility: "hidden"
                                                } : {},
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                    ref: waveformRef
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().timebar),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                                    type: "range",
                                                    min: 0,
                                                    max: 1,
                                                    step: 0.025,
                                                    value: timebarVal,
                                                    style: {
                                                        background: "linear-gradient(to right, #fff 0%, #fff ".concat(timebarVal * 100, "%, #ccc ").concat(timebarVal * 100, "%, #ccc 100%)")
                                                    },
                                                    onChange: handleTimebarChange,
                                                    className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().sliderTime),
                                                    onMouseDown: function() {
                                                        setLastClickTime(timebarVal);
                                                    },
                                                    onMouseUp: function() {
                                                        // call event increase view count
                                                        if (lastClickTime > timebarVal) {
                                                            (0,common_utils__WEBPACK_IMPORTED_MODULE_9__/* .increaseViewCount */ .wh)(id);
                                                        }
                                                        setLastClickTime(-1);
                                                    }
                                                }, "audio-time-slider-".concat(id))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                        className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().controlBtns),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().controlTop),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().skipBtn),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                                                            name: "play-rewind",
                                                            height: 35,
                                                            width: 35,
                                                            onClick: function() {
                                                                return handleTimeSkip(-15);
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        onClick: handlePlayPause,
                                                        style: {
                                                            cursor: "pointer"
                                                        },
                                                        children: mediaControlBtn
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().skipBtn),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                                                            name: "play-forward",
                                                            height: 35,
                                                            width: 35,
                                                            onClick: function() {
                                                                return handleTimeSkip(15);
                                                            }
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().controlBottom),
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().speedCtrl),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().speedCtrlOptions),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_PlayerRateOptions__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                                                                    setPlaybackRate: handleChangePlaybackRate,
                                                                    isWhite: true
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                                className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().speedBtn),
                                                                children: [
                                                                    playbackRate,
                                                                    "x"
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                        className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().progress),
                                                        children: isMiniModeActive ? (0,common_utils__WEBPACK_IMPORTED_MODULE_9__/* .secondsToHms */ .qt)(currentTime) : "".concat((0,common_utils__WEBPACK_IMPORTED_MODULE_9__/* .secondsToHms */ .qt)(currentTime), " / ").concat((0,common_utils__WEBPACK_IMPORTED_MODULE_9__/* .secondsToHms */ .qt)(duration || ((ref = wavesurfer.current) === null || ref === void 0 ? void 0 : ref.getDuration()) || 0))
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                                                        className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().volumeCtrl),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                                                className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().speakerIcon),
                                                                onClick: handleSpeakerClick,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Icon__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP, {
                                                                    name: "speaker",
                                                                    width: 26,
                                                                    height: 26,
                                                                    hasOn: true,
                                                                    isOn: volume > 0.01
                                                                })
                                                            }),
                                                            !isMobile && (isLoading || /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_material_ui_core_Slider__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                                                                defaultValue: 1,
                                                                // waveSurfer recognize value of `0` same as `1`
                                                                //  so we need to set some zero-ish value for silence
                                                                min: 0.01,
                                                                max: 1,
                                                                step: 0.025,
                                                                onChange: handleVolumeChange,
                                                                className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().volumeSlider)
                                                            }, "audio-slider-".concat(id)))
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            canSeeFreeMinutes && isPostDetail && !isMiniModeActive && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().freeTimeSection),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().time),
                        children: (0,common_utils__WEBPACK_IMPORTED_MODULE_9__/* .secondsToHms */ .qt)(Math.max(remainingFreeSeconds, 0))
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                        children: "残りの無料時間"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_common_Button__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                        text: "プライム登録を無料体験",
                        alternateColor: true,
                        onClick: function(e) {
                            handleTrialClick(e);
                        }
                    })
                ]
            })
        ]
    });
}
var ThumbnailImageMini = function(param) {
    var thumbnailUrl = param.thumbnailUrl;
    var linkThumbnailRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    if (!thumbnailUrl) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().thumbnailImageMini),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
            loading: "lazy",
            src: thumbnailUrl,
            ref: linkThumbnailRef,
            onContextMenu: function(e) {
                return e.preventDefault();
            },
            onError: function() {
                return (0,common_utils__WEBPACK_IMPORTED_MODULE_9__/* .loadImageHandleError */ .In)(thumbnailUrl, linkThumbnailRef, function() {
                    if (!linkThumbnailRef.current) return;
                    linkThumbnailRef.current.style.display = "none";
                });
            }
        })
    });
};
var ThumbnailImageFull = function(param) {
    var thumbnailUrl = param.thumbnailUrl, postUrl = param.postUrl, isPostDetail = param.isPostDetail, postId = param.postId, parent = param.parent, postSource = param.postSource, trackTitle = param.trackTitle, postType = param.postType;
    var linkThumbnailRef = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)(null);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var currentAuth = (0,store_global__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(state) {
        return state.currentAuth;
    });
    var showLogin = (0,store_global__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(state) {
        return state.showLogin;
    });
    if (!thumbnailUrl) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {});
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
        className: (_AudioPlayer_module_scss__WEBPACK_IMPORTED_MODULE_20___default().thumbnailImageFull),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
            onClick: function() {
                if (!currentAuth) {
                    showLogin(router.pathname === "/" ? {
                        redirectUrl: postUrl
                    } : {});
                    return;
                }
                if (!isPostDetail) {
                    void router.push(postUrl);
                    (0,common_utils_post__WEBPACK_IMPORTED_MODULE_15__/* .addClickPostEvent */ .lR)({
                        postId: postId,
                        screen: (0,common_utils_pp_tracking__WEBPACK_IMPORTED_MODULE_14__/* .parentKeyToScreenName */ .lF)(parent),
                        postSource: postSource,
                        clickPosition: "media_view",
                        postType: postType,
                        mediaType: service_media__WEBPACK_IMPORTED_MODULE_16__/* .MediaType.Audio */ .D.Audio
                    });
                }
            },
            loading: "lazy",
            alt: trackTitle,
            src: thumbnailUrl,
            ref: linkThumbnailRef,
            onContextMenu: function(e) {
                return e.preventDefault();
            },
            onError: function() {
                return (0,common_utils__WEBPACK_IMPORTED_MODULE_9__/* .loadImageHandleError */ .In)(thumbnailUrl, linkThumbnailRef, function() {
                    if (!linkThumbnailRef.current) return;
                    linkThumbnailRef.current.style.display = "none";
                });
            }
        })
    });
};
var MemoizedAudioPlayer = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.memo(AudioPlayer);
/* harmony default export */ __webpack_exports__["default"] = (MemoizedAudioPlayer);


/***/ }),

/***/ 87978:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"invisible":"AudioPlayer_invisible__rIskP","thumbnailImageFull":"AudioPlayer_thumbnailImageFull__1rNjG","thumbnailImageMini":"AudioPlayer_thumbnailImageMini__Sao19","audioPlayerWrapper":"AudioPlayer_audioPlayerWrapper__DoY54","hidden":"AudioPlayer_hidden__ZiJmf","closeBtn":"AudioPlayer_closeBtn__D_fSc","audioBody":"AudioPlayer_audioBody__7m09H","trackInfo":"AudioPlayer_trackInfo__sc611","trackAuthor":"AudioPlayer_trackAuthor__iDUY5","trackTitle":"AudioPlayer_trackTitle__0_xYL","titleInput":"AudioPlayer_titleInput__B33Hg","bottom":"AudioPlayer_bottom__FjYBi","loading":"AudioPlayer_loading__xyx83","progress":"AudioPlayer_progress__lZaD8","volumeCtrl":"AudioPlayer_volumeCtrl__tShi4","volumeSlider":"AudioPlayer_volumeSlider__cnE1m","speakerIcon":"AudioPlayer_speakerIcon__x90jm","center":"AudioPlayer_center__WX7pl","waveformContainer":"AudioPlayer_waveformContainer__buDK_","timebar":"AudioPlayer_timebar__uI7Yk","sliderTime":"AudioPlayer_sliderTime__ZU2oz","speedCtrl":"AudioPlayer_speedCtrl__VQAu2","speedCtrlOptions":"AudioPlayer_speedCtrlOptions__PM9Yv","speedBtn":"AudioPlayer_speedBtn__rV4Zz","floating":"AudioPlayer_floating__rhLN7","hasThumbnail":"AudioPlayer_hasThumbnail__mAcbP","controlBtns":"AudioPlayer_controlBtns__SvxO1","controlTop":"AudioPlayer_controlTop__cD4p0","skipBtn":"AudioPlayer_skipBtn__huCdB","controlBottom":"AudioPlayer_controlBottom__Pzd9s","freeTimeSection":"AudioPlayer_freeTimeSection__WODS6","time":"AudioPlayer_time__U0FEZ","mini":"AudioPlayer_mini__Xow_Y","dialogWrapper":"AudioPlayer_dialogWrapper__h0AWT"};

/***/ })

}]);